import { useState } from 'react';

export default function VideoTestimonials() {
  const [activeVideo, setActiveVideo] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const videos = [
    {
      id: 1,
      title: 'AI Transformation Success Story',
      company: 'Global Financial Services',
      speaker: 'Sarah Mitchell',
      role: 'Chief Digital Officer',
      duration: '4:32',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20executive%20woman%20in%20modern%20glass%20office%20boardroom%20presenting%20on%20large%20screen%20with%20data%20visualizations%20navy%20blue%20corporate%20atmosphere%20high%20end%20business%20environment&width=640&height=360&seq=video-thumb-1&orientation=landscape',
      description: 'How we achieved 340% ROI on our AI investment with Covasant\'s governance framework.'
    },
    {
      id: 2,
      title: 'From Pilot to Production in 90 Days',
      company: 'Healthcare Enterprise',
      speaker: 'Dr. James Chen',
      role: 'Chief Technology Officer',
      duration: '5:18',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20male%20executive%20in%20sleek%20modern%20healthcare%20technology%20center%20with%20digital%20screens%20showing%20medical%20AI%20analytics%20navy%20blue%20lighting%20corporate%20setting&width=640&height=360&seq=video-thumb-2&orientation=landscape',
      description: 'Scaling our diagnostic AI from pilot to enterprise-wide deployment.'
    },
    {
      id: 3,
      title: 'Covasant Platform Demo',
      company: 'Product Walkthrough',
      speaker: 'Covasant Team',
      role: 'Technical Overview',
      duration: '8:45',
      thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20dashboard%20interface%20on%20large%20monitor%20screen%20showing%20enterprise%20analytics%20workflow%20automation%20navy%20blue%20gradient%20modern%20tech%20office%20environment&width=640&height=360&seq=video-thumb-3&orientation=landscape',
      description: 'See how our AI Operating Model accelerates your transformation journey.'
    }
  ];

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#1e3a8a]/10 text-[#1e3a8a] px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-video-line"></i>
            Video Insights
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            See the <span className="text-[#1e3a8a]">Results</span> in Action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Watch enterprise leaders share their AI transformation journeys and explore our platform capabilities.
          </p>
        </div>

        {/* Main Video Player */}
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Featured Video */}
          <div className="lg:col-span-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gray-900 aspect-video group">
              {!isPlaying ? (
                <>
                  <img
                    src={videos[activeVideo].thumbnail}
                    alt={videos[activeVideo].title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                  
                  {/* Play Button */}
                  <button
                    onClick={handlePlayClick}
                    className="absolute inset-0 flex items-center justify-center cursor-pointer group"
                  >
                    <div className="w-20 h-20 bg-[#1e3a8a] rounded-full flex items-center justify-center shadow-lg shadow-[#1e3a8a]/40 group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-white text-4xl ml-1"></i>
                    </div>
                  </button>

                  {/* Video Info Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="flex items-center gap-2 text-white/70 text-sm mb-2">
                      <i className="ri-time-line"></i>
                      <span>{videos[activeVideo].duration}</span>
                      <span className="mx-2">•</span>
                      <span>{videos[activeVideo].company}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">{videos[activeVideo].title}</h3>
                    <p className="text-white/80">{videos[activeVideo].description}</p>
                  </div>
                </>
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-900">
                  <div className="text-center text-white">
                    <div className="w-16 h-16 border-4 border-[#3b82f6] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-white/70">Video player loading...</p>
                    <button 
                      onClick={() => setIsPlaying(false)}
                      className="mt-4 text-[#3b82f6] hover:text-[#60a5fa] text-sm cursor-pointer"
                    >
                      ← Back to preview
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Live Demo CTA */}
          <div className="flex flex-col justify-center">
            <div className="p-8 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-2xl text-white h-full flex flex-col justify-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-live-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">Want a Live Demo?</h3>
              <p className="text-white/80 mb-6 leading-relaxed">
                Book a personalized walkthrough with our team at Booth TFG 28. See how Covasant accelerates your AI transformation journey.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-white/90">
                  <i className="ri-check-line text-teal-300"></i>
                  <span>Live platform demonstration</span>
                </li>
                <li className="flex items-center gap-3 text-white/90">
                  <i className="ri-check-line text-teal-300"></i>
                  <span>Custom use case discussion</span>
                </li>
                <li className="flex items-center gap-3 text-white/90">
                  <i className="ri-check-line text-teal-300"></i>
                  <span>ROI assessment preview</span>
                </li>
              </ul>
              <a 
                href="#leaders"
                className="inline-flex items-center justify-center gap-2 bg-white text-[#1e3a8a] px-6 py-4 rounded-xl font-bold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Schedule Demo
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
